<template>
  <v-tooltip
    top
    nudge-top="4"
  >
    <template v-slot:activator="{on, attrs}">
      <v-chip
        :disabled="loading"
        small
        outlined
        class="mr-1 mb-1 px-1"
        v-bind="attrs"
        v-on="on"
        @click="onClick"
      >
        <v-icon
          color="primary"
          small
        >
          mdi-paperclip
        </v-icon>
        <span>{{ attachDisplayName }}</span>
      </v-chip>
    </template>
    <span>{{ name }}</span>
  </v-tooltip>
</template>

<script>
import PrintJS from "print-js"

export default {
  props: {
    id: String,
    name: String,
    contentType: String
  },

  data: () => ({
    loading: false
  }),

  computed: {
    attachDisplayName() {
      const maxLen = 20
      const filename =
        this.name.lastIndexOf(".") === -1 ? this.name : this.name.substring(0, this.name.lastIndexOf("."))
      return filename.length > maxLen ? filename.substring(0, maxLen - 1) + "…" : filename
    }
  },

  methods: {
    async onClick() {
      try {
        this.loading = true
        const url = `/mailService/attachmentData/${this.id}`
        if (this.contentType.includes("pdf")) {
          PrintJS(url, "pdf")
        } else if (this.contentType.startsWith("image/")) {
          PrintJS(url, "image")
        } else {
          window.open(url, "_blank")
        }
      } catch (err) {
        this.$notify("error", err.response?.data?.message ? err.response.data.message : "Ошибка при получении вложения")
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
